import styles from "./UnavailableItem.module.css";

export const UnavailableItem = () => {
  return <div className={styles.unavailableItem} />;
};
